// hooks/useDoctorQuery.js
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";
import { useLanguage } from "../context/LanguageContext";
import { slug } from "../utils/store";
import axios from "axios";

const fetchDoctorBySlug = async (slug) => {
    const response = await drEasyApi.get(`/api/Centers/GetCenterbySlug?Slug=${slug}`);
  return response.data;
};

export const useDoctorQuery = (slug2=null) => {
    const { currentLanguage } = useLanguage();

  return useQuery({
    queryKey: ["doctor", slug2||slug,currentLanguage],
    queryFn: () => fetchDoctorBySlug(slug2?slug2:slug),
    enabled: !!slug, // avoid running before slug is available
    retry: false,
  });
};
